/** Anchor Targets Enum
    @readonly
    @enum {string}
*/
export var ANCHORREL;
(function (ANCHORREL) {
    ANCHORREL["NONE"] = "";
    ANCHORREL["ALTERNATE"] = "alternate";
    ANCHORREL["AUTHOR"] = "author";
    ANCHORREL["BOOKMARK"] = "bookmark";
    ANCHORREL["EXTERNAL"] = "external";
    ANCHORREL["FOLLOWER"] = "follower";
    ANCHORREL["HELP"] = "help";
    ANCHORREL["LICENSE"] = "license";
    ANCHORREL["MANIFEST"] = "manifest";
    ANCHORREL["NEXT"] = "next";
    ANCHORREL["PREVIOUS"] = "prev";
    ANCHORREL["SEARCH"] = "search";
    ANCHORREL["TAG"] = "tag";
})(ANCHORREL || (ANCHORREL = {}));
;
